<template>
  <div></div>
</template>

<script>
import axios from 'axios';

export default {
  mounted() {
    axios.get(process.env.VUE_APP_ROOT_API + '/auth/logout', {maxRedirects: 0}).then(() => {
      this.$store.dispatch('license/logOut');
      this.$router.push('login');
    }).catch(() => {
      this.$router.back();
    });
  }
}
</script>
